import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

export const useValidateStringLength: (minLength: number) => (value: string) => string | null = minLength => {
    const {t} = useTranslation(['validation']);
    return useCallback(
        value => {
            if (value.trim().length < minLength) {
                return t('validation:stringLength', {
                    count: minLength,
                    defaultValue: 'Value must be at least {{count}} character.',
                    defaultValue_other: 'Value must be at least {{count}} characters.',
                });
            }
            return null;
        },
        [t, minLength]
    );
};
